import { doc, setDoc } from 'firebase/firestore';
import { OnboardingProgress } from '../../types/obsessless-user';
import { firestore } from '../config/firebase';
import { useLoggedInUser } from './useLoggedInUser';

export interface LoggedInUserEditReturn {
    markFinishedOnboarding: () => Promise<void>;
}

export const useLoggedInUserEdit = () => {
    const user = useLoggedInUser();

    const saveOnboardingProgress = async (progress: OnboardingProgress) => {
        user.onboardingProgress = progress;

        if (progress === OnboardingProgress.FinishedOnboarding) {
            user.hasFinishedOnboarding = true;
        }

        const userRef = doc(firestore, `user_info/${user.uid}`);
        await setDoc(userRef, { onboardingProgress: progress, hasFinishedOnboarding: user.hasFinishedOnboarding }, { merge: true });
    };

    return { saveOnboardingProgress };
}